import Vue from 'vue';
import VueRouter from 'vue-router';
import querystring from 'query-string';
import store from '@/store';
import Login from '../views/Login.vue';
import OrderList from '../views/OrderList.vue';
import OrderDetail from '../views/OrderDetail.vue';
import { KEY } from '@/consts';

function addCorpCode(query, code) {
  const newQuery = {
    ...query
  };
  if (!newQuery[KEY]) {
    newQuery[KEY] = code;
  }
  return newQuery;
}

class LotsRouter extends VueRouter {
  getNewLocation(location) {
    const currentQuery = this.currentRoute.query;
    const code = currentQuery[KEY];
    let newLocation;
    if (typeof location === 'string') {
      const q = querystring.parseUrl(location);
      q.query = addCorpCode(q.query, code);
      newLocation = querystring.stringifyUrl(q);
    } else {
      newLocation = { ...location, query: addCorpCode(location.query, code) };
    }
    return newLocation;
  }

  push(location, onComplete, onAbort) {
    super.push(this.getNewLocation(location), onComplete, onAbort);
  }

  replace(location, onComplete, onAbort) {
    super.replace(this.getNewLocation(location), onComplete, onAbort);
  }
}

Vue.use(LotsRouter);

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/order/list',
    name: 'orderList',
    component: OrderList
  },
  {
    path: '/order/detail',
    name: 'orderDetail',
    component: OrderDetail
  },
  {
    path: '/order/refund',
    name: 'orderRefund',
    component: () =>
      import(/* webpackChunkName: "refund" */ '../views/OrderRefund.vue')
  }
];

const router = new LotsRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && !store.getters.isLogin)
    next(`/?corpCode=${to.query[KEY]}`);
  else next();
});

export default router;
